module.exports = __webpack_public_path__ + "static/img/bg-pt.db0f856f.webp";